import React from 'react';
export const Download = function Download() {
  let {
    height = 24,
    width = 24
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/React.createElement("svg", {
    width: "".concat(width),
    height: "".concat(height),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1001 14.8997L23.1001 21.1996C23.1001 21.8361 22.8403 22.4466 22.3777 22.8967C21.9151 23.3468 21.2877 23.5996 20.6335 23.5996L3.36681 23.5996C2.71261 23.5996 2.08521 23.3468 1.62262 22.8967C1.16003 22.4466 0.900146 21.8361 0.900146 21.1996L0.900146 14.8997M6 9.79984L12 15.7998M12 15.7998L17.9999 9.79984M12 15.7998L11.9999 1.39897",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};